module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10jTOeS/tc-custom/9781569759691.jpg?1705952127532",
      "alt": "This image is the cover for the book Warrior Elite"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Warrior Elite\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Heart-pounding accounts of the courageous men, elite methods, and deadly moments that make up daring special ops missions.")]), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v("They are the strongest, best-trained and most powerfully equipped soldiers in the world. The select few who overcome near-impossible odds. The special ops forces. Presenting real-life stories that read like fictional thrillers, "), _c('i', [_vm._v("Warrior Elite")]), _vm._v(" recounts over two dozen of modern warfare’s most"), _c('br'), _c('br'), _vm._v("riveting, dangerous, and infamous missions. From support amid the lethal chaos of major combat operations, like the rescue of Private Jessica Lynch in Iraq, to targeted military strikes against rogue enemies, like the Navy SEAL sniper shots that saved Captain Richard Phillips from Somali pirates, these are the missions that test the gut level of even the bravest soldier. "), _c('i', [_vm._v("Warrior Elite ")]), _vm._v("brings readers into the heart of the battle to experience the hectic horror of Black Hawk Down, the blind terror of Tora Bora cave warfare, and the triumphant success of MIA rescue missions deep in Laos.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nigel Cawthorne\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Nigel Cawthorne is the author of Serial Killers and Mass Murderers, as well as numerous other books. His writing has appeared in more than 150 newspapers and magazines, including the Financial Times, Sun, Flatbush Life, and The New York Tribune. He lives in London, UK.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Ulysses Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0